import React, { useState, useEffect } from 'react'
import useAxios from '../utils/useAxios'
import EmployerHeader from '../components/EmployerHeader'
import AddCompany from '../components/AddCompany'

function EmployerCompanies() {
    let [companies, setCompanies] = useState([])

    let api = useAxios()

    const baseURL = "http://hamsieexpenses.com"
    // const baseURL = "http://hamsieexpenses.com"

    useEffect(() => {
        getCompanies()
    }, [])

    let getCompanies = async () => {
        let response = await api.get('/api/companies/')
        if (response.status === 200) {
            setCompanies(response.data)
        }
    }


  return (
    <div>
        <EmployerHeader />
        <div className='container'>

            <div className="d-flex justify-content-between">
                <div><h2>My Companies</h2></div>
                <div><button className='btn btn-primary' data-bs-toggle="modal" data-bs-target="#companyModal">Add Company</button></div>
            </div>

            <ul className="list-group mt-5">
                {companies.map(company => (
                    <li key={company.id} className="list-group-item">
                        <img width="25px" className='me-3' alt='logo' src={baseURL + company.image} /> 
                        <span className="fw-bold">{company.name}</span>
                    </li>
                ))}
            </ul>

        </div>

        <AddCompany />

    </div>
  )
}

export default EmployerCompanies